import { FulfillmentPlanOrderGridStatus } from '../../../../enums/fulfillmentplan-order-grid-status';

export const FulfillmentPlannerState = {
  Editable: 'Editable',
  Readonly: 'Readonly',
  AwaitingPayment: 'AwaitingPayment',
  Cancelled: 'Cancelled',
} as const;

export type FulfillmentPlannerState = (typeof FulfillmentPlannerState)[keyof typeof FulfillmentPlannerState];

export const getFulfillmentPlannerStateFromOrderGridStatus = (orderGridStatus: string | undefined): FulfillmentPlannerState => {
  if (
    orderGridStatus === FulfillmentPlanOrderGridStatus.Shipped.name ||
    orderGridStatus === FulfillmentPlanOrderGridStatus.PendingFulfillment.name ||
    orderGridStatus === FulfillmentPlanOrderGridStatus.PendingPickup.name
  ) {
    return FulfillmentPlannerState.Readonly;
  }

  if (orderGridStatus === FulfillmentPlanOrderGridStatus.AwaitingPayment.name) {
    return FulfillmentPlannerState.AwaitingPayment;
  }

  if (orderGridStatus === FulfillmentPlanOrderGridStatus.Cancelled.name) {
    return FulfillmentPlannerState.Cancelled;
  }

  return FulfillmentPlannerState.Editable;
};
